export default {
  content: {
    id: 'product_jp_product_condition_screen_carousel_grade_a_content',
    defaultMessage:
      'There may be slight scratches that are barely visible from a distance of 20cm.',
  },
  pill1: {
    id: 'product_jp_product_condition_screen_carousel_grade_a_pill_1',
    defaultMessage: 'Verified parts',
  },
  grade: {
    id: 'product_jp_grade_10',
    defaultMessage: 'A grade (Excellent)',
  },
}
